import groupTypes  from "../config/groupTypes";

export function getGroupType(groupByIdentifier) {
  if (groupTypes.all === groupByIdentifier) return groupTypes.all;
  if (groupTypes.groups === groupByIdentifier) return groupTypes.groups;
  if (groupTypes.userGroup === groupByIdentifier) return groupTypes.userGroup;
  if (groupTypes.masterGroup === groupByIdentifier) return groupTypes.masterGroup;
}
